<template>
    <div class="flex flex-column">
        <div class="flex flex-column lg:flex-row align-items-baseline my-5">
            <template v-if="emptyUrl()">
                <div>{{ $t('lang.main.zen.notFound') }}</div>
            </template>
            <template v-else>
                <div class="flex flex-nowrap align-items-baseline mb-4 lg:mb-0 dashboard_title__channel_container">
                    <div class="dashboard_title__channel_icon"></div>
                    <h3 class="m-0">
                        <a :href="channelData.url" target="_blank" class="dashboard_title__channel_name">
                            {{ channelData.name }}
                        </a>
                    </h3>
                </div>
                <div class="flex flex-column">
                    <div class="flex flex-wrap row-gap-5 dashboard_title__stats_container column-gap-4">
                        <div>
                            <i class="pi pi-sort-alt mr-2"></i>
                            <div :title="$t('lang.main.zen.rank_position_by_view')" class="mr-1">
                                <a v-if="channelData.countViews > 0" :href="getViewsRatingPage" target="_blank">{{ formatNumber(channelData.countViewsRank) }}</a>
                                <span v-else>{{ formatNumber(maxStatValue) }}</span>
                            </div>
                            <span class="mr-1">/</span>
                            <div :title="$t('lang.main.zen.rank_position_by_till_end')">
                                <a v-if="channelData.countTillEnd > 0" :href="getViewsTillEndRatingPage" target="_blank">{{ formatNumber(channelData.countTillEndRank) }}</a>
                                <span v-else>{{ formatNumber(maxStatValue) }}</span>
                            </div>
                        </div>
                        <div v-if="!channelData.isActive">
                            <i class="pi pi-tag mr-2"></i>
                            <span>{{ $t('lang.main.zen.delete') }}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div v-if="descriptionNonEmpty" class="mb-5">
            {{ channelData.description }}
        </div>
    </div>
</template>

<script>
import {FormatHelper} from "../../../../helpers/FormatHelper";
import Alerts from "../../../../mixins/Alerts";
import {get} from "lodash";

export default {
    name: "ZenDashboardChannelTitle",
    mixins: [Alerts],
    data() {
        return {
            // максимальное значение для вывода
            maxStatValue: 1000000,
        }
    },
    props: {
        channelId: {
            type: String,
            required: true
        },
        ratingsPerPage: {
            type: Number,
            default: 25,
        },
        channelData: {
            type: Object,
            default: null
        },
    },
    computed: {
        descriptionNonEmpty() {
            return _.isString(this.channelData.description) && this.channelData.description.length > 0
        },
        /**
         * Ссылка на страницу рейтинга по просмотрам, на которой находится канал
         */
        getViewsRatingPage() {
            const pageNum = this.getPageNum(this.getRank('countViewsRank'), this.ratingsPerPage);
            return this.getRatingPage('dzen/views-rating', pageNum);
        },
        /**
         * Ссылка на страницу рейтинга по дочитываниям, на которой находится канал
         */
        getViewsTillEndRatingPage() {
            const pageNum = this.getPageNum(this.getRank('countTillEndRank'), this.ratingsPerPage);
            return this.getRatingPage('dzen/views-till-end-rating', pageNum);
        },
        getLogo() {
            return 'url(' + this.channelData.logo + ')';
        }
    },
    methods: {
        emptyUrl() {
            return _.isNull(this.channelData.url)
        },
        getRank(type) {
            return get(this.channelData, type) || 1;
        },
        getPageNum(num, perPage) {
            return Math.floor((num - 1) / perPage) + 1;
        },
        getRatingPage(ratingURI, pageNum) {
            return sprintf('/%s/%s?domain=%s#page=%d&per_page=%d', window.locale, ratingURI, this.channelId, pageNum, this.ratingsPerPage);
        },
        formatNumber(number) {
            return FormatHelper.number(number);
        },
    }
}
</script>

<style scoped src="../../../../../c/pages/dashboards.css"></style>
<style scoped>
.dashboard_title__channel_icon {
    background-image: v-bind(getLogo);
}
.dashboard_title__channel_name {
    color: #495057;
    font-size: 24px;
    font-weight: 400;
    word-break: break-word;
    line-height: 1.2;
}
</style>
